import { RadioGroup as RadioGroupReact } from '@headlessui/react'
import clsx from 'clsx'

export type RadioGroupItem = {
  name: string
  description: string
  value?: string | number
}

interface RadioGroupProps {
  select: RadioGroupItem
  handleSelect: (item: RadioGroupItem) => void
  options: RadioGroupItem[]
}

const RadioGroup: React.FC<RadioGroupProps> = ({ options, select, handleSelect }) => {
  return (
    <RadioGroupReact value={select} onChange={handleSelect}>
      <RadioGroupReact.Label className="sr-only">Privacy setting</RadioGroupReact.Label>
      <div className="-space-y-px rounded-md bg-white">
        {options.map((setting, settingIdx) => (
          <RadioGroupReact.Option
            key={setting.name}
            value={setting}
            className={({ checked }) =>
              clsx(
                settingIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '',
                settingIdx === options.length - 1 ? 'rounded-bl-md rounded-br-md' : '',
                checked ? 'z-10 border-brand-200 bg-brand-50' : 'border-gray-200',
                'relative flex cursor-pointer border p-4 focus:outline-none'
              )
            }
          >
            {({ active, checked }) => (
              <>
                <span
                  className={clsx(
                    checked ? 'border-transparent bg-brand-600' : 'border-gray-300 bg-white',
                    active ? 'ring-2 ring-brand-500 ring-offset-2' : '',
                    'mt-0.5 flex h-4 w-4 cursor-pointer items-center justify-center rounded-full border'
                  )}
                  aria-hidden="true"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-white" />
                </span>
                <div className="ml-3 flex flex-col">
                  <RadioGroupReact.Label
                    as="span"
                    className={clsx(checked ? 'text-brand-900' : 'text-gray-900', 'block text-sm font-medium')}
                  >
                    {setting.name}
                  </RadioGroupReact.Label>
                  <RadioGroupReact.Description
                    as="span"
                    className={clsx(checked ? 'text-brand-700' : 'text-gray-500', 'block text-sm')}
                  >
                    {setting.description}
                  </RadioGroupReact.Description>
                </div>
              </>
            )}
          </RadioGroupReact.Option>
        ))}
      </div>
    </RadioGroupReact>
  )
}

export default RadioGroup
